import React from "react";
import "../CompoundSlider.scss";
import PropTypes from "prop-types";
import { formatAndShortenMoney } from "../../../../utils/common";

export class Tick extends React.Component {
  static propTypes = {
    count: PropTypes.number,
    tick: PropTypes.shape({
      percent: PropTypes.number,
      value: PropTypes.number,
    }),
  };

  render() {
    const { count, tick } = this.props;
    return (
      <div>
        <div
          className="tickStyle"
          style={{
            left: `${tick.percent}%`,
          }}
        />
        <div
          className="tickStyle2"
          style={{
            marginLeft: `${-(100 / count) / 2}%`,
            width: `${100 / count}%`,
            left: `${tick.percent}%`,
          }}
        >
          {formatAndShortenMoney(tick.value)}
        </div>
      </div>
    );
  }
}

export default Tick;
